// extracted by mini-css-extract-plugin
export default {"content":"MentionsLegales_content__ZR9IA"};